import React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import { getToken, isAuthenticated, TOKEN_KEY, TOKEN_DATE } from '../store/auth';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'
import { callApi } from '../helpers/methods'
import * as roles from '../store/roles';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionsPrivate } from '../store/auth';

//LAYOUT
import PrivateLayout from '../layouts/private'

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Return } from '../components/inspinia'
import Ibox from '../components/painel/ibox'
import { EMAIL, SMS } from '../store/tipoListaEmail';
import TemPermissao from '../helpers/TemPermissao';

class Painel extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            emailsEnviados: 0,
            emailsEntregues: 0,
            emailsAbertos: 0,
            emailsRejeitados: 0,
            totalEmails: 0,
            optionState: '',
            lastCampaigns: [],
            dadosCarregados: false,


            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.LoadDashboard();
    }

    LoadDashboard() {
        let self = this;
        let auth = this.props.auth;

        if (!auth.isAuthenticated) {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(TOKEN_DATE);
            document.getElementById('btSair').click();
            return;
        }

        const url = `${c.DASHBOARD}`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({
                ...self.state, loading: false,
                lastCampaigns: response.ultimasCampanhas,
                dadosCarregados: response.carregado
            });
        });
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    statusCampanha(status) {
        if (status == "Agendado") {
            return (<span class="label label-warning">{status}</span>)
        }
        else if (status == "Enviado") {
            return (<span class="label label-primary">{status}</span>)
        }
        else if (status == "Rascunho") {
            return (<span class="label label-success">{status}</span>)
        }
    }

    editarCampanha(campanha) {

    }

    iconeEnvio(tipoIcone) {
        if (tipoIcone == "Simples") {
            return (<img className="justify-content-center mr-3 ml-2" src="assets/images/001-send.svg" />)
        }
        else if (tipoIcone == "Rastreado Verificar") {
            return (<img className="justify-content-center mr-3 ml-2" src="assets/images/007-checked.svg" />)
        } else {
            return (<img className="justify-content-center mr-3 ml-2" src="assets/images/006-search.svg" />)
        }
    }

    render() {

        return (
            <PrivateLayout navActiveItem={c.NAV_PANEL}>

                <TemPermissao permissoes={[roles.ROLE_EMAIL, roles.ROLE_SMS]}>
                    <Row style={{ display: 'flex', justifyContent: 'center' }}>
                        <Column size="8">
                            <IBox>
                                <Title>
                                    <h5>Últimas campanhas</h5>
                                </Title>

                                {!this.state.dadosCarregados && (
                                    <div className="p-3 row">
                                        <div className="sk-spinner sk-spinner-three-bounce">
                                            <div className="sk-bounce1"></div>
                                            <div className="sk-bounce2"></div>
                                            <div className="sk-bounce3"></div>
                                        </div>
                                    </div>
                                )}

                                <div className="container" style={{
                                    width: "100%",
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    maxHeight: "586px"
                                }}>

                                    {this.state.lastCampaigns.length === 0 && this.state.dadosCarregados && (
                                        <div className="ibox-content p-3 row">
                                            <table className="d-flex justify-content-center">
                                                <tr><td colSpan="5" scope="row">Nenhuma campanha encontrada.</td></tr>
                                            </table>
                                        </div>
                                    )}

                                    {this.state.lastCampaigns.map(campanha => {

                                        let idCampanha = campanha.idCampanha;
                                        let urlEditar = "";

                                        if (campanha.tipoCampanha === SMS) {
                                            urlEditar = "/campanha/nova-sms/" + idCampanha;
                                        } else {
                                            urlEditar = "/campanha/nova/" + idCampanha;
                                        }

                                        return (
                                            <div className="ibox-content p-3 row">
                                                <table className="d-flex justify-content-center">
                                                    <tr>
                                                        <th></th> {/* Ícone */}
                                                        <th></th> {/* Enviados */}
                                                        <th></th> {/* Entregues */}
                                                        <th></th> {/* Abertos */}
                                                        <th></th> {/* Rejeitados */}
                                                    </tr>
                                                    <tr>
                                                        <table>
                                                            <tr>
                                                                <td colSpan="1" className="text-center">
                                                                    {this.statusCampanha(campanha.statusCampanha)}
                                                                </td>
                                                                <td colSpan="4" className="text-left">
                                                                    <b><span style={{ opacity: 0.8, fontSize: '14px', color: 'darkslategrey' }}> {campanha.nomeCampanha}</span></b>
                                                                    {campanha.statusCampanha == "Rascunho" &&
                                                                        <a href={urlEditar}>
                                                                            <img className="ml-2" src="assets/images/edit.svg" />
                                                                        </a>
                                                                    }

                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center  col-4">
                                                                    {this.iconeEnvio(campanha.tipoEnvio)}


                                                                    {campanha.statusCampanha == "Agendado" &&
                                                                        <span style={{ opacity: 0.7, fontSize: '11px' }}> {campanha.dataCampanhaAgendada}</span>
                                                                    }

                                                                    {campanha.statusCampanha !== "Agendado" &&
                                                                        <span style={{ opacity: 0.7, fontSize: '11px' }}> {campanha.dataCampanha}</span>
                                                                    }


                                                                </td>

                                                                <td className="text-center  col-2">
                                                                    <CircularProgressBar tipo="Enviados" porcentagem={campanha.porcentagemEmailEnviado} quantidade={campanha.quantidadeEmailEnviado} total={campanha.quantidadeEmailEnviado} />
                                                                    <h4>{campanha.quantidadeEmailEnviado}</h4>
                                                                    Enviados
                                                                </td>

                                                                <td className="text-center  col-2">
                                                                    <CircularProgressBar tipo="Entregues" porcentagem={campanha.porcentagemEmailEntregue} quantidade={campanha.quantidadeEmailEntregue} total={campanha.quantidadeEmailEnviado} />
                                                                    <h4>{campanha.quantidadeEmailEntregue}</h4>
                                                                    Entregues
                                                                </td>


                                                                <td className="text-center  col-2">
                                                                    <CircularProgressBar tipo="Abertos" porcentagem={campanha.porcentagemEmailAberto} quantidade={campanha.quantidadeEmailAberto} total={campanha.quantidadeEmailEnviado} />
                                                                    <h4>{campanha.quantidadeEmailAberto}</h4>
                                                                    {campanha.tipoCampanha === EMAIL && <span>Abertos</span>}
                                                                    {campanha.tipoCampanha === SMS && <span>Entregues no Aparelho</span>}
                                                                </td>

                                                                <td className="text-center  col-2">
                                                                    <CircularProgressBar tipo="Rejeitados" porcentagem={campanha.porcentagemEmailRejeitado} quantidade={campanha.quantidadeEmailRejeitados} total={campanha.quantidadeEmailEnviado} />
                                                                    <h4>{campanha.quantidadeEmailRejeitados}</h4>
                                                                    Rejeitados
                                                                </td>

                                                                <td className="text-center  col-2">
                                                                    <CircularProgressBar tipo="Invalidos" porcentagem={campanha.porcentagemEmailInvalido} quantidade={campanha.quantidadeEmailInvalidos} total={campanha.quantidadeEmailEnviado} />
                                                                    <h4>{campanha.quantidadeEmailInvalidos}</h4>
                                                                    Inválidos
                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </tr>
                                                </table>
                                            </div>
                                        );
                                    })}
                                </div>
                            </IBox>
                        </Column>
                    </Row>
                </TemPermissao>

            </PrivateLayout>
        );
    }
}

class PainelTopo extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = { quantidadeEmail: 0, totalEmail: 0 }
    }

    componentDidMount() {

        this.state.quantidadeEmail = this.props.quantidade;
    }

    handleChange(event) {
        alert(event.target.value)

    }

    render() {
        return (
            <IBox>
                <Content>
                    <table>
                        <tr>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr>
                            <td>
                                <h1>{this.props.qtdeEmail}</h1>
                            </td>
                            <td>

                            </td>
                        </tr>
                    </table>
                </Content>
            </IBox>
        );
    }
}

class CircularProgressBar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        let total = this.props.quantidade - this.props.total;
        let quantidade = this.props.quantidade;
        let porcentagem = this.props.porcentagem;
        let tipo = this.props.tipo;
        let progressColor;

        const sqSize = this.props.sqSize;
        const viewBox = `0 0 ${sqSize} ${sqSize}`;
        const dashArray = this.props.radius * Math.PI * 2;
        let dashOffset;

        // const dashOffset = dashArray - (total/quantidade)*dashArray;
        dashOffset = dashArray - 0.01 * (porcentagem * dashArray);
        if (porcentagem == 0) {
            progressColor = "#BBBBBB";
        }

        if (tipo == "Enviados") {
            progressColor = "#0099FF";
        }
        else if (tipo == "Entregues") {
            progressColor = "#009966";
        }
        else if (tipo == "Abertos") {
            progressColor = "#C34E4E";
        }
        else if (tipo == "Rejeitados") {
            progressColor = "#836BAE";
        }
        else if (tipo == "Invalidos") {
            progressColor = "#CC8331";
        }

        return (
            <svg
                width={this.props.sqSize}
                height={this.props.sqSize}
                viewBox={viewBox}>
                {/* Circulo de fundo */}
                <circle
                    cx={this.props.sqSize / 2} cy={this.props.sqSize / 2} r={this.props.radius}
                    strokeWidth={`${this.props.strokeWidth}px`} style={{ fill: "none", stroke: "#BBBBBB" }}
                />

                {/* Circulo de progresso */}
                <circle
                    cx={this.props.sqSize / 2} cy={this.props.sqSize / 2} r={this.props.radius}
                    strokeWidth={`${this.props.strokeWidth}px`} transform={`rotate(-90 ${this.props.sqSize / 2} ${this.props.sqSize / 2})`}
                    style={{
                        strokeDasharray: dashArray,
                        strokeDashoffset: dashOffset,
                        stroke: progressColor,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        fill: "none"
                    }} />
                <text
                    className="circle-text" x="50%" y="50%" dy=".3em"
                    style={{ fontSize: "1em", fontWeight: "bold" }}
                    textAnchor="middle">
                    {this.props.porcentagem}%
                </text>
            </svg>
        );
    }
}



CircularProgressBar.defaultProps = {
    sqSize: 80,
    radius: 30,
    strokeWidth: 7
};

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: {} };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Painel));
